import axios from 'axios'
import { TokenService } from '@/services/storage.service'
//Vue.use(Router)
const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        return axios.get(resource)
    },

    post(resource, data) {
        return axios.post(resource, data).then(response => {
            return response.data;
        }).catch(error => {
             if(error.response && error.response.data){
                if(error.response.data.message == 'Unauthenticated.') {
                    localStorage.clear();
                    window.location="/";
                }else if(error.response.status==500){
                   //  window.location="/500";
                 }
                return error.response.data;
            }else
                return error.response;
        })
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data)
    },
    checkAuth(response){
    console.log(response)
        /*if(data.message=='Unauthenticated.'){
            TokenService.removeToken()
            this.removeHeader()
            $this.$router.push('Login')
        }
        return response*/
    }

}

export default ApiService